module.exports = "/_next/static/images/visacard-duotone-f15b5b4320c19c99032bdf1d8da2af68.svg";